import Styled from "@emotion/styled";

export const SiteImage = Styled.img`
    width: 100%;
    border-radius: 4px;
    height: 300px;
    object-fit: contain;
`;